module.exports = __webpack_public_path__ + "img/2_B.4771f529.webp";